import React from "react";
import { Link } from "react-router-dom";

const SOCIAL_LINKS = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/share/18j8FycJVe/?mibextid=wwXIfr",
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
        <path d="M22 12.07C22 6.48 17.52 2 11.93 2S1.86 6.48 1.86 12.07c0 5.02 3.66 9.18 8.44 9.93v-7.02H7.9v-2.91h2.4V9.41c0-2.37 1.4-3.68 3.56-3.68 1.03 0 2.11.18 2.11.18v2.32h-1.19c-1.17 0-1.54.73-1.54 1.48v1.78h2.62l-.42 2.91h-2.2V22c4.78-.75 8.44-4.91 8.44-9.93z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/dynesourcerltd/",
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
        <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2zm-.2 2A3.6 3.6 0 0 0 4 7.6v8.8A3.6 3.6 0 0 0 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6A3.6 3.6 0 0 0 16.4 4H7.6zm9.65 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/dynesourcer",
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
        <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.73V1.73C24 .77 23.21 0 22.23 0z" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@dynesourcerUK",
    icon: (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor" aria-hidden="true">
        <path d="M23.5 6.2a3.02 3.02 0 0 0-2.12-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.38.56A3.02 3.02 0 0 0 .5 6.2 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.8 3.02 3.02 0 0 0 2.12 2.14C4.5 20.5 12 20.5 12 20.5s7.5 0 9.38-.56a3.02 3.02 0 0 0 2.12-2.14A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.8zM9.75 15.02V8.98L15.5 12l-5.75 3.02z" />
      </svg>
    ),
  },
];

function SocialLinks({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {SOCIAL_LINKS.map((item) => (
        <a
          key={item.name}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.name}
          title={item.name}
          className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-white/5 text-slate-300 transition-colors hover:border-sky-400/50 hover:bg-sky-500/20 hover:text-white"
        >
          {item.icon}
        </a>
      ))}
    </div>
  );
}

export default function SiteFooter() {
  const regulatoryText =
    "Dynesourcer Ltd is an IAR (Introducing Appointed Representative) of Dynamic Commercial Finance Ltd (CN 13195176) registered office Unit 1 Old Greens Norton Road, Towcester NN12 8AX. Dynamic Commercial Finance Ltd is authorised & regulated by the Financial Conduct Authority. Our firm reference number is 946483. You can check via www.register.fca.org.uk. We receive commission from lenders. Different lenders pay different amounts depending on different commission models: fixed fee, fixed rate of commission & percentage of the amount you borrow. Further details of the commission model, calculation and amount will be disclosed to you through your customer journey. ICO ZC062560";

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div>
          <div className="text-white font-black text-2xl mb-4">Dynesourcer</div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Specialist mortgage sourcing. Borrowers pick by product; lenders manage listings & analytics.
          </p>
          <SocialLinks className="mt-5" />
        </div>

        <div>
          <div className="text-sm font-bold text-white mb-4">For Lenders</div>
          <ul className="space-y-3 text-sm">
            <li><Link className="hover:text-white transition-colors" to="/contact">Register</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/signin?force=true&next=/lender/overview">Lender Portal</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-bold text-white mb-4">For Borrowers</div>
          <ul className="space-y-3 text-sm">
            <li><Link className="hover:text-white transition-colors" to="/sourcing/buy-to-let-mortgage-sourcing">Source products</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/borrowers">Our products</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/buy-to-let-mortgage-calculator">BTL Mortgage Calculator</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/explore-borrower-journey">Explore Borrower Journey</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-bold text-white mb-4">Company</div>
          <ul className="space-y-3 text-sm">
            <li><Link className="hover:text-white transition-colors" to="/about">About Us</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/blog">Blogs/News</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/contact">Contact Us</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <p className="text-xs text-slate-400 leading-relaxed mb-6">
            {regulatoryText}
          </p>
          <p className="text-center text-sm text-slate-400">
            © {new Date().getFullYear()} Dynesourcer. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
